const clientIndexRouter = [

  // 终端数量指标分配
  {
    path: '/jurisdictionSystem/client-target-import/:cls',
    name: 'jurisdictionSystemClientTargetImport',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/ClientTargetImport'
        '@/views/jurisdiction-manage/index-manage/client-index/ClientImport.vue'
        ),
    meta: {
      SecondaryMenu: '终端指标', //二级菜单
      title: '终端数量指标分配'
    }
  },


  // 指标统计
  {
    path: '/jurisdictionSystem/target-statistics/:meta_type/:cls/:module_int',
    name: 'jurisdictionSystemClientTargetStatistics',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/Page.vue'
        '@/views/jurisdiction-manage/index-manage/client-index/Statistics/Page.vue'
        ),
    meta: {
      SecondaryMenu: '终端指标', //二级菜单
      isMoreMeta: true,
      1: {
        title: '按部门统计'
      },
      2: {
        title: '按终端统计'
      },
      3: {
        title: '按产品统计'
      },
      4: {
        title: '按岗位统计'
      }
    }
  },


  // 岗位金额指标分配
  {
    path: '/jurisdictionSystem/quarter-target-import',
    name: 'jurisdictionSystemQuarterTargetImport',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/QuarterTargetImport'
        '@/views/jurisdiction-manage/index-manage/client-index/QuarterImport.vue'
        ),
    meta: {
      SecondaryMenu: '综合指标', //二级菜单
      title: '岗位金额指标分配'
    }
  },


  {
    path: '/jurisdictionSystem/export/:meta_type/:cls/:module_int',
    name: 'jurisdictionSystemExport',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/export'
        '@/views/jurisdiction-manage/index-manage/client-index/Statistics/Export.vue'
        ),
    meta: {
      SecondaryMenu: '销售指标', //二级菜单
      isMoreMeta: true,
      2: {
        title: '历史指标导出',
        breadcrumb: [
          {
            title: '按终端统计',
            name: 'jurisdictionSystemClientTargetStatistics'
          }
        ]
      },
      4: {
        title: '历史岗位指标导出',
        breadcrumb: [
          {
            title: '按岗位统计',
            name: 'jurisdictionSystemClientTargetStatistics'
          }
        ]
      }
    }
  },


  // 客户指标确认
  {
    path: '/jurisdictionSystem/new-saleindex/hospital-index-confirmation',
    name: 'jurisdictionSystemNewSaleindexHospitalIndexConfirmation',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/newSaleindex/HospitalIndexConfirmation.vue'
        '@/views/jurisdiction-manage/index-manage/customer-index/confirm/Page.vue'
        ),
    meta: {
      SecondaryMenu: '客户指标管理', //二级菜单
      isMoreMeta: true,
      title: '客户指标确认'
    }
  },


  // 客户指标管理 操作日志
  {
    path: '/jurisdictionSystem/new-saleindex/log/:type',
    name: 'jurisdictionSystemNewSaleindexLog',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/newSaleindex/log'
        '@/views/jurisdiction-manage/index-manage/customer-index/confirm/Log.vue'
        ),
    meta: {
      SecondaryMenu: '客户指标管理', //二级菜单
      isMoreMeta: true,
      title: '操作日志',
      breadcrumb: [
        {
          title: '客户指标确认',
          name: 'jurisdictionSystemNewSaleindexHospitalIndexConfirmation'
        }
      ]
    }
  },


  // 指标更新调整
  {
    path: '/jurisdictionSystem/new-saleindex/index-update',
    name: 'jurisdictionSystemNewSaleindexIndexUpdate',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/newSaleindex/IndexUpdate.vue'
        '@/views/jurisdiction-manage/index-manage/customer-index/update/Page.vue'
        ),
    meta: {
      SecondaryMenu: '客户指标管理', //二级菜单
      isMoreMeta: true,
      title: '指标更新调整'
    }
  },


  // 导入调整值
  {
    path: '/jurisdictionSystem/new-saleindex/import-adjust-value',
    name: 'jurisdictionSystemNewSaleindexImportAdjustValue',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/newSaleindex/ImportAdjustValue'
        '@/views/jurisdiction-manage/index-manage/customer-index/update/Import.vue'
        ),
    meta: {
      SecondaryMenu: '客户指标管理', //二级菜单
      title: '导入调整值',
      breadcrumb: [
        {
          title: '指标更新调整',
          name: 'jurisdictionSystemNewSaleindexIndexUpdate'
        }
      ]
    }
  },


  // 指标更新查看
  {
    path: '/jurisdictionSystem/new-saleindex/hospital-index-select',
    name: 'jurisdictionSystemNewSaleindexHospitalIndexSelect',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/newSaleindex/HospitalIndexSelect.vue'
        '@/views/jurisdiction-manage/index-manage/customer-index/check/Page.vue'
        ),
    meta: {
      SecondaryMenu: '客户指标管理', //二级菜单
      isMoreMeta: true,
      title: '指标更新查看'
    }
  },


  // 客户指标  按部门、按客户、按产品、按岗位
  {
    path: '/jurisdictionSystem/target-new-statistics/:meta_type/:cls',
    name: 'jurisdictionSystemClientTargetNewStatistics',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/NewStatistics.vue'
        '@/views/jurisdiction-manage/index-manage/customer-index-statistical/Page.vue'
        ),
    meta: {
      SecondaryMenu: '终端指标', //二级菜单
      isMoreMeta: true,
      1: {
        title: '按部门统计'
      },
      2: {
        title: '按客户统计'
      },
      3: {
        title: '按产品统计'
      },
      4: {
        title: '按岗位统计'
      }
    }
  },


  // 指标分配  岗位指标分配
  {
    path: '/jurisdictionSystem/quarter-target-import-plan2',
    name: 'jurisdictionSystemQuarterTargetImport2',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/QuarterTargetImportPlan2.vue'
        '@/views/jurisdiction-manage/index-manage/index-distribution/quarter-index-distri/Import.vue'
        ),
    meta: {
      SecondaryMenu: '综合指标', //二级菜单
      title: '岗位指标分配'
    }
  },


  // 岗位指标进度查询
  {
    path: '/jurisdictionSystem/target-schedule-quarter-query',
    name: 'targetQuarterScheduleQuery',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/TargetQuarterScheduleQuery.vue'
        '@/views/jurisdiction-manage/index-manage/index-distribution/quarter-index-check/Page.vue'
        ),
    meta: {
      SecondaryMenu: '综合指标', //二级菜单
      title: '指标进度查询',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig'
        }
      ]
    }
  },


  // 终端指标进度查询
  {
    path: '/jurisdictionSystem/target-schedule-client-query',
    name: 'targetClientScheduleQuery',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/TargetClientScheduleQuery.vue'
        '@/views/jurisdiction-manage/index-manage/index-distribution/client-index-check/Page.vue'
        ),
    meta: {
      SecondaryMenu: '综合指标', //二级菜单
      title: '指标进度查询',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig'
        }
      ]
    }
  },
    //岗位销售统计
    {
      path: '/jurisdictionSystem/metric-tatistics/:meta_type',
      name: 'metricStatistics',
      component: () =>
        import(
          /*webpackChunkName:"jurisdictionSystemTarget" */
          // '@/views/jurisdictionSystem/target/TargetQuarterScheduleQuery.vue'
          '@/views/jurisdiction-manage/index-manage/index-distribution/metric-tatistics/Page.vue'
          ),
      meta: {
        SecondaryMenu: '综合指标', //二级菜单
        title: '指标进度查询',
        breadcrumb: [
          {
            title: '系统配置',
            name: 'flowSystemConfig'
          }
        ]
      }
    },
    // 客户统计
    {
      path: '/jurisdictionSystem/user-tatistics',
      name: 'userStatistics',
      component: () =>
        import(
          /*webpackChunkName:"jurisdictionSystemTarget" */
          // '@/views/jurisdictionSystem/target/TargetQuarterScheduleQuery.vue'
          '@/views/jurisdiction-manage/index-manage/index-distribution/user-statistics/Page.vue'
          ),
      meta: {
        SecondaryMenu: '综合指标', //二级菜单
        title: '指标进度查询',
        breadcrumb: [
          {
            title: '系统配置',
            name: 'flowSystemConfig'
          }
        ]
      }
    },
];

export default clientIndexRouter;